<template>
  <path
    d="M19 19.0002H21V21.0002H19V19.0002ZM19 17.0002H21V15.0002H19V17.0002ZM3 13.0002H5V11.0002H3V13.0002ZM3 17.0002H5V15.0002H3V17.0002ZM3 9.00018H5V7.00018H3V9.00018ZM3 5.00018H5V3.00018H3V5.00018ZM7 5.00018H9V3.00018H7V5.00018ZM15 21.0002H17V19.0002H15V21.0002ZM11 21.0002H13V19.0002H11V21.0002ZM15 21.0002H17V19.0002H15V21.0002ZM7 21.0002H9V19.0002H7V21.0002ZM3 21.0002H5V19.0002H3V21.0002ZM21 8.00018C21 5.24018 18.76 3.00018 16 3.00018H11V5.00018H16C17.65 5.00018 19 6.35018 19 8.00018V13.0002H21V8.00018Z"
  />
</template>
